(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sculpt-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-sc-fit-dialog]').forEach(dialog => {
        if (dialog.dataset.fitReady === 'true') return;
        const root = dialog.closest('.sc');
        if (!root || typeof dialog.showModal !== 'function') return;
        dialog.dataset.fitReady = 'true';
        let opener = null;
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 });
        root.addEventListener('click', event => {
          const trigger = event.target.closest('[data-size-open]');
          if (!trigger || !root.contains(trigger)) return;
          event.preventDefault();
          if (dialog.open) return;
          opener = trigger;
          dialog.showModal();
          dialog.scrollTop = 0;
        });
        root.querySelectorAll('[data-size-open]').forEach(trigger => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', dialog.id);
        });
        dialog.querySelector('[data-fit-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {
          if (opener && opener.isConnected) opener.focus({ preventScroll: true });
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        dialog.querySelectorAll('[data-fit-unit]').forEach(button => {
          button.addEventListener('click', () => {
            const unit = button.dataset.fitUnit;
            dialog.querySelectorAll('[data-fit-unit]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
            dialog.querySelectorAll('[data-fit-cm]').forEach(cell => {
              const cm = Number(cell.dataset.fitCm);
              cell.textContent = formatter.format(unit === 'in' ? cm / 2.54 : cm);
            });
            dialog.querySelectorAll('[data-fit-caption]').forEach(caption => { caption.hidden = caption.dataset.fitCaption !== unit; });
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
